import { SvgIcon } from "@mui/material";
import React from "react";

export default function CarPlaceholderIcon({ stroke = "#297EFF", ...props }: any) {
  return (
    <SvgIcon
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M15.8334 14.1667H17.5C18 14.1667 18.3334 13.8334 18.3334 13.3334V10.8334C18.3334 10.0834 17.75 9.41671 17.0834 9.25004C15.5834 8.83337 13.3334 8.33337 13.3334 8.33337C13.3334 8.33337 12.25 7.16671 11.5 6.41671C11.0834 6.08337 10.5834 5.83337 10 5.83337H4.16669C3.66669 5.83337 3.25002 6.16671 3.00002 6.58337L1.83335 9.00004C1.723 9.3219 1.66669 9.65979 1.66669 10V13.3334C1.66669 13.8334 2.00002 14.1667 2.50002 14.1667H4.16669"
          stroke={stroke}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83335 15.8333C6.75383 15.8333 7.50002 15.0871 7.50002 14.1667C7.50002 13.2462 6.75383 12.5 5.83335 12.5C4.91288 12.5 4.16669 13.2462 4.16669 14.1667C4.16669 15.0871 4.91288 15.8333 5.83335 15.8333Z"
          stroke={stroke}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 14.1666H12.5"
          stroke={stroke}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1667 15.8333C15.0871 15.8333 15.8333 15.0871 15.8333 14.1667C15.8333 13.2462 15.0871 12.5 14.1667 12.5C13.2462 12.5 12.5 13.2462 12.5 14.1667C12.5 15.0871 13.2462 15.8333 14.1667 15.8333Z"
          stroke={stroke}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
